<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">{{ $t('emailAccountAccessAndSignaturesModalTitle') }}</div>
    </template>
    <Spinner v-if="dataIsSending"/>
    <div v-else-if="accountData?.id">

      <div class="p-mb-2">
        <span class="p-text-secondary">{{ $t('Email Account') }}:</span> <span class="medium-bold-text">{{ accountData.username }}</span>
      </div>
      <div class="p-text-secondary p-mb-3">
        {{ $t('emailAccountImplicitAccessInfo') }}
      </div>

<!--      <AddNewButton-->
<!--          :disabled="availableEmployeesToAdd.length === 0"-->
<!--          style="width:auto;"-->
<!--          :label="$t('addUser')"-->
<!--          @click="addUserAccessOnClick"/>-->
<!--      <AddNewButton v-if="$store.getters.isOwnerOrHigher || accountData.canManageAccess"-->
<!--                    :disabled="availableEmployeesToAdd.length === 0"-->
<!--                    style="width:auto;"-->
<!--                    :label="$t('addUser')"-->
<!--                    @click="addUserAccessOnClick"/>-->
      <AddNewButton
          :disabled="availableEmployeesToAdd.length === 0"
          style="width:auto;"
          :label="$t('addUser')"
          @click="addUserAccessOnClick"/>

      <div class="p-mt-4 p-pb-3 table-wrapper" v-if="emailUsers?.length">
        <table class="p-datatable p-datatable-striped p-datatable-sm p-datatable-hoverable-rows users-table">
          <thead class="p-datatable-thead">
          <tr>
            <th style="min-width: 180px">{{ $t('User') }}</th>
            <th>{{ $t('Role') }}</th>
            <th style="max-width: 170px">{{ $t('canViewEmailsLabel') }}</th>
<!--            <th style="max-width: 170px">{{ $t('canManageEmailAccessLabel') }}</th>-->
            <th>{{ $t('emailSignatureLabel') }}</th>
            <th style="width: 96px"></th>
          </tr>
          </thead>
          <tbody class="p-datatable-tbody">
          <tr v-for="(user, index) of emailUsers"
              :key="index"
              :class="{'updated-item': isItemUpdated(user.emailUserId)}">
            <td>
                <div class="p-d-flex p-ai-center">
                  <i class="ti-user p-mr-2"/>
                  <div>{{ user.full_name }}</div>
                </div>
            </td>

            <td>
              <span v-if="user.role">{{ roleLabel(user.role) }}</span>
              <i class="ti-minus" v-else/>
            </td>

            <td>
              <i class="ti-check" v-if="user.can_view_inbox"/>
              <i class="ti-close" v-else/>
            </td>

<!--            <td>-->
<!--              <i class="ti-check" v-if="user.role === constants.userRoles.owner"/>-->
<!--              <i class="ti-check" v-else-if="user.role === constants.userRoles.admin && user.can_manage_access"/>-->
<!--              <i class="ti-close" v-else-if="user.role === constants.userRoles.admin && !user.can_manage_access"/>-->
<!--              <i class="ti-minus" v-else/>-->
<!--            </td>-->

            <td>
              <i v-if="user.signature" style="font-size: 1.1em" v-tooltip.top="user.signature" class="ti-comment-alt"></i>
              <i v-else class="ti-minus"/>
            </td>
            <td>
              <div class="actions">
<!--                <EditButton @click="editUserAccess(user)"-->
<!--                            :disabled="user.role <= constants.userRoles.admin && !$store.getters.isOwnerOrHigher"/>-->
<!--                <EditButton @click="editUserAccess(user)"-->
<!--                            :disabled="user.role <= constants.userRoles.admin && !$store.getters.isOwnerOrHigher && !user.isCurrentUser"/>-->
<!--                <DeleteButton @click="confirmDeleteUserAccess(user)"-->
<!--                              :disabled="user.role <= constants.userRoles.admin && !$store.getters.isOwnerOrHigher"/>-->
                <EditButton @click="editUserAccess(user)"
                            :disabled="!canEditUserAccess(user)"/>

                <DeleteButton @click="confirmDeleteUserAccess(user)"
                              :disabled="!canDeleteUserAccess(user)"/>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="no-data-block">{{ $t('No data available') }}</div>
    </div>
    <EmailAccountUserModal :visible="emailUserModal"
                           :employees="employeesData"
                           :item="emailUser"
                           :emailAccountId="accountData.id"
                           @close="closeEmailUserModal"
                           @update-items="updateItems"
                           @update-item="updateItem"/>

    <ConfirmDeleteModal
        :modalDataIsLoading="modalDataIsLoading"
        :visible="confirmDeleteUserAccessModal"
        @close="closeConfirmDeleteUserAccessModal"
        @delete-item="deleteUserAccess"/>

    <template #footer>
      <Button :label="$t('Close')" icon="pi pi-times" class="p-button-text" @click="close"/>
    </template>
  </Modal>
</template>

<script>
import httpClient from '@/services/http.services'
import EmailAccountUserModal from "@/pages/settings/components/EmailAccountUserModal";
import formatMixins from '@/mixins/formatMixins';
import showErrorsMixins from "@/mixins/showErrorsMixins";
import inputsFormatMixins from "@/mixins/inputsFormatMixins";
import constants from "@/constants";

export default {
  mixins: [ showErrorsMixins, formatMixins, inputsFormatMixins ],
  components: { EmailAccountUserModal },
  emits: ['close', 'update-items'],
  name: 'EmailAccountUsersModal',
  props: {
    item: Object,
    employees: {
      type: [Array, null],
      default: null,
    },
    visible: Boolean,
  },
  data() {
    return {
      modalDataIsLoading: false,
      dataIsSending: false,
      employeesData: [],
      emailUserToDelete: {},
      confirmDeleteUserAccessModal: false,
      updatedItemId: null,
      accountData: {},
      emailUsers: [],
      emailUser: {},
      emailUserModal: false,
      constants
    }
  },
  watch: {
    item(value) {
      if (!value) return false
      this.accountData = {
        ...value,
      }

      // if (value.emailUsers?.length) {
      //   this.emailUsers = value.emailUsers.map(u => ({
      //         emailUserId: u.id,
      //         user_id: u.userData?.id,
      //         role: u.userData?.effective_role,
      //         // ...user.userData,
      //         full_name: (u.userData?.first_name || '') + ' ' + (u.userData?.last_name || ''),
      //         can_view_inbox: u.can_view_inbox,
      //         can_manage_access: u.can_manage_access,
      //         signature: u.signature
      //       }
      //   ))
      // }

      // this.emailUsers = Array.isArray(value.emailUsers)
      //     ? value.emailUsers.map(u => ({
      //       emailUserId: u.id,
      //       user_id: u.userData?.id,
      //       role: u.userData?.effective_role,
      //       full_name: `${u.userData?.first_name || ''} ${u.userData?.last_name || ''}`.trim(),
      //       can_view_inbox: u.can_view_inbox,
      //       can_manage_access: u.can_manage_access,
      //       signature: u.signature
      //     }))
      //     : []

      this.emailUsers = Array.isArray(value.emailUsers)
          ? value.emailUsers.map(u => ({
            emailUserId: u.id,
            user_id: u.userData?.id,
            role: u.userData?.effective_role,
            full_name: `${u.userData?.first_name || ''} ${u.userData?.last_name || ''}`.trim(),
            can_view_inbox: u.can_view_inbox,
            // can_manage_access: u.can_manage_access,
            signature: u.signature,
            isCurrentUser: !!u.isCurrentUser,
          }))
          : []
    },
    visible() {
      if (!this.visible) {
        this.dataIsSending = false
        this.accountData = {}
        this.emailUsers = []
        this.employeesData = []
        this.emailUserToDelete = {}
        this.updatedItemId = null
        this.emailUser = {}
      }
    },
    '$store.state.secondLayerIsOpened'() {
      if (!this.$store.state.secondLayerIsOpened) {
        if (this.emailUserModal) {
          this.closeEmailUserModal()
        }
        if (this.confirmDeleteUserAccessModal) {
          this.closeConfirmDeleteUserAccessModal()
        }
      }
    },
  },
  methods: {
    updateItems(id) {
      this.$emit('update-items', id)
    },
    updateItem(user) {
      // if (user.isNew) {
      //   this.emailUsers.push(user)
      // } else {
      if (user.isNew) {
        this.emailUsers.push({
          ...user,
          isCurrentUser:
              Number(user.user_id) === Number(this.$store.state.user?.id),
        })
      } else {
        let foundUser = this.emailUsers.find(u => u.emailUserId === user.emailUserId)
        if (foundUser) {
          foundUser.id = user.id
          foundUser.full_name = user.full_name
          foundUser.role = user.role
          foundUser.can_view_inbox = user.can_view_inbox
          // foundUser.can_manage_access = user.can_manage_access
          foundUser.signature = user.signature
        }
      }

      if (user.emailUserId) {
        this.updatedItemId = user.emailUserId
      }
    },
    canEditUserAccess(user) {
      if (this.$store.getters.isOwnerOrHigher) {
        return true
      }

      return user.isCurrentUser
          || user.role > constants.userRoles.admin
    },

    canDeleteUserAccess(user) {
      if (this.$store.getters.isOwnerOrHigher) {
        return true
      }

      return user.role > constants.userRoles.admin
    },
    addUserAccessOnClick() {
      this.emailUser = {}
      this.emailUserModal = true
      this.$store.commit('toggleSecondLayer', true)
      this.generateEmployeesData()
    },
    editUserAccess(user) {
      this.emailUser = user
      this.emailUserModal = true
      this.$store.commit('toggleSecondLayer', true)
      this.generateEmployeesData()
    },
    generateEmployeesData() {
      const userIdsSet = new Set()
      this.emailUsers.forEach(u => {
        userIdsSet.add(u.user_id)
      })
      const userIdsArray = [...userIdsSet]
      this.employeesData = []

      this.employees?.forEach(e => {
        if (userIdsArray.indexOf(e.id) === -1 || e.id === this.emailUser?.user_id) {
          this.employeesData.push(e)
        }
      })
    },
    confirmDeleteUserAccess(user) {
      this.emailUserToDelete = user
      this.confirmDeleteUserAccessModal = true
      this.$store.commit('toggleSecondLayer', true)
    },
    closeConfirmDeleteUserAccessModal() {
      this.emailUserToDelete = {}
      this.confirmDeleteUserAccessModal = false
      this.$store.commit('toggleSecondLayer', false)
    },
    async deleteUserAccess() {
      this.modalDataIsLoading = true
      try {
        const { status, data } = await httpClient.post('email-account/delete-email-account-user', { emailUserId: this.emailUserToDelete.emailUserId })
        if (status === 200 && data?.success) {
          await this.$store.dispatch('reloadLocationBootstrapData')

          this.emailUsers = this.emailUsers.filter(u => u.emailUserId !== this.emailUserToDelete.emailUserId)
          this.$emit('update-items', this.accountData.id)
          this.emailUserToDelete = {}
          this.closeConfirmDeleteUserAccessModal()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.modalDataIsLoading = false
      }
    },
    closeEmailUserModal() {
      this.emailUser = {}
      this.emailUserModal = false
      this.$store.commit('toggleSecondLayer', false)
    },
    isItemUpdated(itemId) {
      return this.updatedItemId === itemId
    },
    close() {
      this.$emit('close')
    },
  },
  computed: {
    availableEmployeesToAdd() {
      const idsWithAccess = new Set((this.emailUsers ?? []).map(u => u.user_id))
      return (this.employees ?? []).filter(e => !idsWithAccess.has(e.id))
    },
    computedWindowSize() {
      if (this.$store.state.mobileLayout) {
        return {position: 'absolute', top: '15px', width: '94%', marginTop: '10px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: '15px', width: '90%', maxWidth: '900px', marginTop: '15px'}
      } else {
        return {position: 'absolute', top: '15px', width: '87%', maxWidth: '900px'}
      }
    },
  },

}
</script>

<style scoped lang="scss">
.table-wrapper {
  overflow-y: auto;
}

.users-table {
  border-collapse: collapse;
  width: 100%;
  .users-table__name {
    //width: 90%;
    //width: auto;
  }
  .users-table__buttons {
    //width: 100%;
  }
}
</style>